<template>
  <div v-if="role === 'retoucher'" class="uk-width-auto uk-text-center">
    <div class="tm-order-count uk-box-shadow-medium 3">
      <div>
        <md-icon>pending_actions</md-icon>
        {{count_new_orders}} / {{count_personal_orders}}
      </div>
    </div>
    <div class="uk-dropdown tm-dropdown tm-dropdown-left-top" data-uk-dropdown="pos: left-top; offset: 15">
      {{ getTooltipContent }}
    </div>
  </div>
</template>
<script>
export default {
  name: "CountNewOrders",
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    downtime: {
      type: Object,
      require: true,
    },
    role: {
      type: String,
      require: true,
    },

  },
  data: () => ({

  }),
  methods: {
    async fetchCountNewOrders() {
      let data;

      this.$emit("fetch-personal-orders-count", this.count_personal_orders);
    },

  },
  async mounted() {
  },
  created() {

  },
  computed: {
    count_new_orders(){

      return this.downtime && this.downtime.count_new_orders ? this.downtime.count_new_orders : 0;
    },
    count_personal_orders(){
      return this.downtime && this.downtime.count_personal_orders ? this.downtime.count_personal_orders : 0;
    },
    getTooltipContent() {
      return this.local_page_keys.tooltip_order_count_part_1 + ' ' + this.count_new_orders + ' ' + this.local_page_keys.tooltip_order_count_part_2 + ' ' + this.count_personal_orders + ' ' + this.local_page_keys.tooltip_order_count_part_3;
    }
  },
  beforeDestroy() {
  }
}
</script>